import { ComponentProps, FC, useCallback, useEffect } from "react"
import { surnameUpdateApi } from "src/domain/api/surname/surnameUpdateApi"
import { Surname } from "../../../../domain/entities/surname"
import { useAuth, useSubCasteListApi } from "../../../../domain/hooks"
import { FormikOnSubmit } from "../../../../utils/types"
import { ISurnameUpdateFormFields } from "./ISurnameUpdateFormFields"
import { SurnameUpdateDrawerFormView } from "./SurnameUpdateDrawerFormView"

type Props = Omit<
	ComponentProps<typeof SurnameUpdateDrawerFormView>,
	"handleSubmit" | "subCasteList"
> & {
	onSuccess?: (surname: Surname) => void
}

export const SurnameUpdateDrawerFormController: FC<Props> = ({
	surname,
	onSuccess,
	...rest
}) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<ISurnameUpdateFormFields>>(
		async (values, { setErrors }) => {
			try {
				const updatedSurname = await surnameUpdateApi(
					{ id: surname.id, update: values },
					token,
				)
				onSuccess && onSuccess(updatedSurname)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ name: message })
			}
		},
		[onSuccess, rest, token, surname.id],
	)

	const { fetchSubCasteList, subCasteList } = useSubCasteListApi()

	useEffect(() => {
		fetchSubCasteList()
	}, [fetchSubCasteList])

	return (
		<SurnameUpdateDrawerFormView
			surname={surname}
			subCasteList={subCasteList}
			handleSubmit={handleSubmit}
			{...rest}
		/>
	)
}
